import { render, staticRenderFns } from "./innovate_award.vue?vue&type=template&id=230dd1d7&scoped=true"
import script from "./innovate_award.vue?vue&type=script&lang=js"
export * from "./innovate_award.vue?vue&type=script&lang=js"
import style0 from "./innovate_award.vue?vue&type=style&index=0&id=230dd1d7&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230dd1d7",
  null
  
)

export default component.exports